import { render, staticRenderFns } from "./PoptipBroadcast.vue?vue&type=template&id=978db8fe&scoped=true&"
import script from "./PoptipBroadcast.vue?vue&type=script&lang=js&"
export * from "./PoptipBroadcast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978db8fe",
  null
  
)

export default component.exports